import React from 'react';
import { connect } from 'react-redux';
// react plugin used to create switch buttons
import DashboardLayout from "layouts/Admin"

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Label
} from "reactstrap";
import Chart from "react-google-charts";
import "react-circular-progressbar/dist/styles.css";
// core components
import { PanelHeader } from "components";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import documentsIcon from "assets/img/documents.svg"
import queryIcon from "assets/img/query.svg"
import subjectsIcon from "assets/img/subject.svg"
import { DashboardActions, DocumentActions } from "actions";
import { Routes } from 'constants/index';
import { RemoteTable } from "components";
import { crfVerifiedTableColumns, dataPendingColumns } from './TableColumns';
import { PAGE_SIZE } from "api/list";

const options = {
    legend: "none",
    toolTip: 'none',
    chartArea: {
        left: 30,
        right: 20,
        bottom: 20,
        top: 20
    },
    height: 250,
    tooltip: {
        trigger: 'none'
    },
    bar: {
        groupWidth: 36
    }
};

class PMDashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dePendingPage : 1,
            crfPage : 1
        };

    }

    componentDidMount() {
        const { token, site } = this.props;
        if (this.props && site && site._id) {
            this.props.getMyMetrics(token, site._id)
            let documentParams = `studySite.id=${site._id}&isCCRAVerified=true&docType=CRF`;
            this.props.getCRFVerifiedDocumentsCount(token, documentParams);
            this.props.getCRFVerifiedDocuments(token, documentParams, 0, PAGE_SIZE);
            documentParams = documentParams.concat('&deCompletedBy_null=true');
            this.props.getDEPendingDocumentsCount(token, documentParams);
            this.props.getDEPendingDocuments(token, documentParams, 0, PAGE_SIZE);
        }
    }

     handleTableChange = (type, paging) => {
        let start = (paging.page - 1) * paging.sizePerPage;
        let documentParams = `studySite.id=${this.props.site._id}&isCCRAVerified=true&docType=CRF`;
        if (type === 'dataPending') {
            documentParams = documentParams.concat('&deCompletedBy_null=true');
            this.props.getDEPendingDocuments(this.props.token, documentParams, start, paging.sizePerPage);
            this.setState({ dePendingPage : paging.page });
        } else if (type === 'crfVerified') {
            this.props.getCRFVerifiedDocuments(this.props.token, documentParams, start, paging.sizePerPage);
            this.setState({ crfPage : paging.page });
        }
    }
    
    onDocumentClick = (event, row, rowIndex) => {
        this.props.history.push(`${Routes.DOCUMENTS}/${row.uploadGroup}`)
    }

    render() {
        const { subjectMetrics, documentMetrics, queryMetrics } = this.props.data ? this.props.data : {};
        const { verifiedCRFDocs, pendingDEDocs, dataPendingCount, count } = this.props
        
        return (
            <DashboardLayout>
                <PanelHeader size="sm" />
                <div className="content">
                    <Row>
                        <Col lg="4" sm="6" tag="a" href={Routes.DOCUMENTS}>
                            <Card className="card-stats">
                                <CardBody className="dashboard-card bg-blue">
                                    <div className="statistics statistics-horizontal">
                                        <div className="info info-horizontal">
                                            <Row className="d-flex align-items-center">
                                                <Col className="text-left" xs="9">
                                                    <h1 className="dashboard-card-title">{documentMetrics ? documentMetrics.totalUploaded : 0}</h1>
                                                    <Label className="dashboard-card-subtitle">Total Documents</Label>
                                                </Col>
                                                <Col xs="3">
                                                    <div className="icon icon-circle bg-blue-light" style={{ boxShadow: 'none' }}>
                                                        <img alt="..." src={documentsIcon} style={{ margin: '22px' }} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="4" sm="6" tag="a">
                            <Card className="card-stats">
                                <CardBody className="dashboard-card bg-green">
                                    <div className="statistics statistics-horizontal">
                                        <div className="info info-horizontal">
                                            <Row className="d-flex align-items-center">
                                                <Col className="text-left" xs="9">
                                                    <h1 className="dashboard-card-title">{queryMetrics ? queryMetrics.totalQueries : 0}</h1>
                                                    <Label className="dashboard-card-subtitle">Total Queries</Label>
                                                </Col>
                                                <Col xs="3">
                                                    <div className="icon icon-circle bg-green-light" style={{ boxShadow: 'none' }}>
                                                        <img alt="..." src={queryIcon} style={{ margin: '20px' }} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="4" sm="6" tag="a">
                            <Card className="card-stats">
                                <CardBody className="dashboard-card bg-pink">
                                    <div className="statistics statistics-horizontal">
                                        <div className="info info-horizontal">
                                            <Row className="d-flex align-items-center">
                                                <Col className="text-left" xs="9">
                                                    <h1 className="dashboard-card-title">{subjectMetrics ? subjectMetrics.totalSubjects : 0}</h1>
                                                    <Label className="dashboard-card-subtitle">Total Trial Participants</Label>
                                                </Col>
                                                <Col xs="3">
                                                    <div className="icon icon-circle bg-pink-light" style={{ boxShadow: 'none' }}>
                                                        <img alt="..." src={subjectsIcon} style={{ margin: '22px' }} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" sm="12">
                            <Card style={{ maxHeight: '334px', minHeight: '334px' }}>
                                <CardHeader>
                                    <CardTitle className="graph-card-title">Outstanding Queries Based on Query Type</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Chart
                                        chartType="ColumnChart"
                                        options={options}
                                        data={[
                                            ["Element", "Density", { role: "style" }],
                                            ["SDV Queries", queryMetrics ? queryMetrics.totalSDVQueries : 0, "#F15A67"], // RGB value
                                            ["Meta Data", queryMetrics ? queryMetrics.totalMetaDataQueries : 0, "#F9A50F"], // English color name
                                            ["Source Data", queryMetrics ? queryMetrics.totalSourceDataQueries : 0, "#31ABB9"],
                                            ["Image Queries", queryMetrics ? queryMetrics.totalImageQueries : 0, "color: #BFCE65"], // CSS-style declaration
                                            ["EDC Queries", queryMetrics ? queryMetrics.totalEDCQueries : 0, "#FF7F50"]
                                        ]}
                                        legendToggle
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="6" sm="12">
                            <Card style={{}}>
                                <CardHeader>
                                    <CardTitle className="graph-card-title">Queries Resolved</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <div className='mx-auto' style={{ width: "200px" }}>
                                        <CircularProgressbarWithChildren
                                            value={Math.round(queryMetrics && queryMetrics.totalQueries > 0 ? (queryMetrics.totalQueriesResolved / queryMetrics.totalQueries) * 100 : 0)}
                                            strokeWidth={5}
                                            styles={buildStyles({
                                                strokeLinecap: 'butt',
                                                textColor: 'black',
                                                pathColor: `#426cb5`,
                                                trailColor: 'rgba(66, 181, 169, .2)',
                                            })} >
                                            <div>{Math.round(queryMetrics && queryMetrics.totalQueries > 0 ? (queryMetrics.totalQueriesResolved / queryMetrics.totalQueries) * 100 : 0)}%</div>
                                            <div>Queries</div>
                                            <div>Resolved</div>
                                        </CircularProgressbarWithChildren>
                                    </div>
                                    <Row>
                                        <Col className='text-center'>
                                            <div className='circular-graph-legend mx-auto' style={{ backgroundColor: "rgba(66, 181, 169, .2)" }}></div>
                                            <div>Queries Raised</div>
                                            <div >{queryMetrics ? queryMetrics.totalQueries : 0}</div>
                                        </Col>
                                        <Col className='text-center'>
                                            <div className='circular-graph-legend mx-auto bg-primary'></div>
                                            <div>Queries Resolved</div>
                                            <div >{queryMetrics ? queryMetrics.totalQueriesResolved : 0}</div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" sm="12">
                            <Card style={{ minHeight: '80px' }}>
                                <CardHeader>
                                    <CardTitle className="graph-card-title">CRF Documents Verified</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <RemoteTable
                                        columns={crfVerifiedTableColumns((this.state.crfPage -1) * PAGE_SIZE)}
                                        onTableChange={(type, paging) => this.handleTableChange('crfVerified', paging)}
                                        data={verifiedCRFDocs}
                                        onItemClick={this.onDocumentClick}
                                        page={this.state.crfPage}
                                        sizePerPage={PAGE_SIZE}
                                        totalSize={count}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="6" sm="12">
                            <Card style={{ minHeight: '80px' }}>
                                <CardHeader>
                                    <CardTitle className="graph-card-title">Data Entry Pending Documents</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <RemoteTable
                                        columns={dataPendingColumns((this.state.dePendingPage -1) * PAGE_SIZE)}
                                        onTableChange={(type, paging) => this.handleTableChange('dataPending', paging)}
                                        data={pendingDEDocs}
                                        onItemClick={this.onDocumentClick}
                                        page={this.state.dePendingPage}
                                        sizePerPage={PAGE_SIZE}
                                        totalSize={dataPendingCount}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </DashboardLayout>
        );
    }

}

const mapStateToProps = ({ user, dashboard, studies, sites, documents }) => {
    return {
        token: user.token,
        data: dashboard.metrics,
        verifiedCRFDocs: documents.data || [],
        pendingDEDocs: documents.dataPending || [],
        count : documents.count,
        dataPendingCount : documents.dataPendingCount,
        study: studies.current,
        site: sites.current
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMyMetrics: (token, siteId) => DashboardActions.getSSRMetrics(dispatch, token, siteId),
        getDEPendingDocuments: (token, params, start, limit) => DocumentActions.getDataPendingDocuments(dispatch, token, params, start, limit),
        getDEPendingDocumentsCount: (token, params) => DocumentActions.getDataPendingDocumentsCount(dispatch, token, params),
        getCRFVerifiedDocuments: (token, params, start, limit) => DocumentActions.getDocuments(dispatch, token, params, start, limit),
        getCRFVerifiedDocumentsCount: (token, params) => DocumentActions.getDocumentsCount(dispatch, token, params)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PMDashboard);